import "core-js/modules/es.array.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('FormItem', {
    staticClass: "ivu-form-item-required",
    staticStyle: {
      "margin-bottom": "32px"
    },
    attrs: {
      "label": _vm.label
    }
  }, [_c('Input', {
    class: _vm.errorClass,
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "type": _vm.inputType.type,
      "maxlength": "20"
    },
    on: {
      "on-change": _vm.change,
      "on-blue": _vm.change
    },
    scopedSlots: _vm._u([{
      key: "suffix",
      fn: function () {
        return [_c('Icon', {
          attrs: {
            "type": _vm.inputType.icon
          },
          on: {
            "click": _vm.changeEye
          }
        })];
      },
      proxy: true
    }])
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showtip,
      expression: "showtip"
    }],
    staticClass: "ivu-form-item-error-tip flex gap-1 items-center",
    style: {
      color: _vm.validTip.color
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ['weak', 'strong', 'medium'].includes(_vm.strengthLevel),
      expression: "['weak', 'strong', 'medium'].includes(strengthLevel)"
    }],
    class: `w-[10px] h-[10px] rounded-full`,
    style: {
      background: _vm.validTip.color
    }
  }), _vm._v(" " + _vm._s(_vm.validTip.text) + " ")])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };